export const USER_PREFERENCES_QUERY = `
query UserPreferencesQuery {
  user {
    preferences {
      default_locale
      default_time_zone
      default_unit_system
    }
  }
}
`;
